import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from './Link';
import Spinner from '../Navigation/Spinner';

import './Button.module.css';

const Button = React.forwardRef(
  (
    { arrow, children, color, loading, small, styles, url, className, ...rest },
    ref
  ) => (
    <Link
      to={loading ? null : url}
      className={className}
      styleName={classNames('default-button', arrow, color, {
        small,
        loading
      })}
      style={styles}
      {...rest}
    >
      <span styleName="content" ref={ref}>
        {loading && (
          <span styleName="spinner">
            <Spinner size={2} color={color !== 'dark' ? '#1082f0' : '#fff'} />
          </span>
        )}
        <span>{children || ''}</span>
      </span>
    </Link>
  )
);

Button.propTypes = {
  url: PropTypes.string,
  arrow: PropTypes.oneOf([
    'left',
    'right',
    'none',
    'right-caret',
    'left-caret'
  ]),
  color: PropTypes.oneOf([
    'dark',
    'light',
    'white',
    'light-blue',
    'reverse-blue',
    'inherit-color'
  ]),
  loading: PropTypes.bool,
  small: PropTypes.bool,
  children: PropTypes.node,
  styles: PropTypes.object
};

Button.defaultProps = {
  arrow: 'none',
  color: 'dark',
  loading: false,
  small: false
};

export default Button;
